import Button from "@/common/components/Button";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { ArrowBigRightIcon, BriefcaseBusinessIcon, CarFrontIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { maintenanceForwardingEntryTypeLabel, maintenanceForwardingStepLabel } from "@shared/maintenance/forwardingEntryLabels";
import { MaintenanceForwardingData, MaintenanceForwardingTableItem } from "../types/maintenanceForwarding.type";

export class MaintenanceForwardingsTransformer {

  static tableTransformer() {
    return (forwardings: MaintenanceForwardingData[]): MaintenanceForwardingTableItem[] => {
      return forwardings.map((forwarding) => {
        return {
          ...forwarding,
          protocol_number: forwarding.workflow?.protocol_number || '--',
          forwarding: (
            <div className="flex flex-col">
              <p>
                Tipo: {maintenanceForwardingEntryTypeLabel(forwarding.directive_entry_type)}
              </p>

              {forwarding.current_step && (
                <p className="text-xs italic">
                  Etapa: {`${maintenanceForwardingStepLabel(forwarding.current_step)} - ${maintenanceForwardingEntryTypeLabel(forwarding.current_entry_type)}`}
                </p>
              )}

              <p className="text-xs italic">
                Status: {forwarding.translated_status_of_ongoing_entry || '--'}
              </p>
            </div>
          ),
          equipment: (
            <ImageWithDisplayName
              placeholderIcon={CarFrontIcon}
              imageUrl={forwarding.workflow?.equipment?.photos?.[0]?.url}
              displayName={forwarding.workflow?.equipment?.field_for_display_value}
              caption={forwarding.workflow?.equipment?.model?.display_name}
            />
          ),
          company: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={forwarding.workflow?.company?.general_information?.company_logo?.url}
              displayName={forwarding.workflow?.company?.general_information?.fantasy_name}
            />
          ),
          actions: (
            <Link to={`/maintenance-workflows/${forwarding.workflow?.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Establishment::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    }
  }

}
